import Immutable from 'immutable';

/**
 * Returns a flat list of coupon adjustment items, each paired with its source
 * product title. Reads adjustments from the order item itself
 * (attributes.adjustments) so the product↔adjustment link is data-driven, not
 * positional. Only coupon-driven promotions are included — a volume discount
 * (staffelkorting) has its own overlay and must never be labelled as a coupon.
 */
export const getPromotionAdjustmentItems = (products) => products.flatMap((product) => {
  const productTitle = product.getIn([
    'relationships',
    'purchased_entity',
    'relationships',
    'product_id',
    'attributes',
    'title',
  ]);
  const adjustments = product
    .getIn(['attributes', 'adjustments'], Immutable.List())
    .filter((adj) => adj.get('type') === 'promotion' && adj.get('is_coupon'));

  return adjustments.map((adj) => ({
    key: `${product.get('id')}_${adj.get('source_id', '')}`,
    productTitle,
    couponName: adj.get('promotion_label', '') || '',
    amount: adj.getIn(['total', 'formatted'], ''),
    percentage: parseFloat(adj.get('percentage') || 0),
  }));
});
